import { CSSProperties } from "react";
import styled from "styled-components";

import { Caption } from "@components/Typography";

export const CaptionText = styled(Caption)`
  text-transform: uppercase;
  font-size: 0.88em;
`;

export const styles: Record<string, CSSProperties> = {
  wrapper: {
    display: "flex",
    flex: 1,
    alignItems: "flex-start",
    marginTop: 120,
  },
  subheader: {
    fontWeight: 500,
  },
};
